import classnames from 'classnames';
import React, { ReactElement, ReactNode } from 'react';

interface TableHeadProps {
	children: ReactNode;
	className?: string;
	style?: React.CSSProperties;
}

const EMPTY_STYLE = {};

const TableHead: React.FC<TableHeadProps> = ({ children, className = '', style = EMPTY_STYLE }) => {
	return (
		<div className={classnames('flex border-b border-secondary-light bg-primary-light pr-2 font-bold', className)} style={style}>
			{React.isValidElement(children)
				? React.cloneElement(children as ReactElement, {
						isTableHead: true,
					})
				: children}
		</div>
	);
};

export default TableHead;
